/* Subscribe Radio – Shop name theme
   Rich design with VIP badge, benefits, frequency inside card.
   Integrates with bundle-pack-addon.js and simple bundle-picker. */
(function () {
  function init(container) {
    if (!container) return;

    var productId = container.dataset.productId;
    var discountPercentage = Number(container.dataset.discountPercentage || 0);
    var sellingPlanId = container.dataset.sellingPlanId || '';
    var defaultSubscription = container.dataset.defaultSubscription === 'true';
    var locale = container.dataset.locale || 'fr-FR';
    var currency = container.dataset.currency || 'EUR';
    var showFrequency = container.dataset.showFrequencySelector === 'true';
    var defaultFrequency = container.dataset.defaultFrequency || '';
    var radios = container.querySelectorAll('input[type="radio"][name="purchase_option_' + productId + '"]');
    var subscribeCard = container.querySelector('.subscribe-radio__card--subscribe');
    var onetimeCard = container.querySelector('.subscribe-radio__card--onetime');
    var frequencyWrap = container.querySelector('.subscribe-radio__frequency');
    var frequencySelect = container.querySelector('.subscribe-radio__frequency-select');
    var benefitsWrap = container.querySelector('.subscribe-radio__benefits');
    var variantsScript = container.querySelector('.subscribe-radio-variants');
    var variants = [];
    try {
      variants = JSON.parse(variantsScript && variantsScript.textContent || '[]');
    } catch (_) {}

    /* ── bundle price state ── */
    var bundlePrice = null;
    var bundlePriceBeforeDiscount = null;

    /* ── helpers ── */

    function getCurrentVariant() {
      var section = container.closest('.shopify-section, [id^="MainProduct"], product-info');
      var variantInput = section
        ? section.querySelector('input[name="id"]')
        : document.querySelector('input[name="id"]');
      var id = variantInput ? variantInput.value : null;
      return variants.find(function (v) { return String(v.id) === String(id); });
    }

    function formatMoney(amount) {
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(amount / 100).replace(/\s/g, '');
      } catch (_) {
        return (amount / 100).toFixed(2);
      }
    }

    function parsePriceString(str) {
      if (!str) return null;
      var cleaned = str.replace(/[^\d.,]/g, '').trim();
      if (!cleaned) return null;
      var lastComma = cleaned.lastIndexOf(',');
      var lastDot = cleaned.lastIndexOf('.');
      if (lastComma > lastDot) {
        cleaned = cleaned.replace(/\./g, '').replace(',', '.');
      } else if (lastDot > lastComma) {
        cleaned = cleaned.replace(/,/g, '');
      }
      var value = parseFloat(cleaned);
      if (isNaN(value)) return null;
      return Math.round(value * 100);
    }

    function getEffectivePrice() {
      var variant = getCurrentVariant();
      if (bundlePrice !== null && bundlePrice > 0) {
        return {
          price: bundlePrice,
          compareAtPrice: bundlePriceBeforeDiscount && bundlePriceBeforeDiscount > bundlePrice
            ? bundlePriceBeforeDiscount : null,
          source: 'bundle'
        };
      }
      if (!variant) return null;
      return {
        price: variant.price,
        compareAtPrice: variant.compare_at_price && variant.compare_at_price > variant.price
          ? variant.compare_at_price : null,
        source: 'variant'
      };
    }

    /* ── visual state: active card, show/hide frequency & benefits ── */

    function applyVisualState(selected) {
      var isSub = selected === 'subscribe';

      if (subscribeCard) {
        if (isSub) subscribeCard.classList.add('is-active');
        else subscribeCard.classList.remove('is-active');
      }
      if (onetimeCard) {
        if (!isSub) onetimeCard.classList.add('is-active');
        else onetimeCard.classList.remove('is-active');
      }
      /* frequency selector always visible */
      if (benefitsWrap) benefitsWrap.style.display = isSub ? 'flex' : 'none';
    }

    /* ── price updates on the radio cards ── */

    function updatePrices(isSubscription) {
      var effective = getEffectivePrice();
      if (!effective) return;

      // Subscription card prices
      var subOriginal = container.querySelector('.subscribe-radio__sub-original');
      var subFinal = container.querySelector('.subscribe-radio__sub-final');
      if (subOriginal && subFinal) {
        var discount = Math.round(effective.price * discountPercentage / 100);
        var finalPrice = effective.price - discount;
        subOriginal.textContent = formatMoney(effective.compareAtPrice || effective.price);
        subFinal.textContent = formatMoney(finalPrice);
        subOriginal.style.display = 'inline';
      }

      // One-time card prices
      var otOriginal = container.querySelector('.subscribe-radio__onetime-original');
      var otFinal = container.querySelector('.subscribe-radio__onetime-final');
      if (otOriginal && otFinal) {
        if (effective.compareAtPrice) {
          otOriginal.textContent = formatMoney(effective.compareAtPrice);
          otOriginal.style.display = 'inline';
          otFinal.textContent = formatMoney(effective.price);
        } else {
          otOriginal.style.display = 'none';
          otFinal.textContent = formatMoney(effective.price);
        }
      }
    }

    /* ── submit-button price update ── */

    function updateButtonPrice(isSubscription) {
      var effective = getEffectivePrice();
      if (!effective) return;

      var priceDisplay = document.querySelector('[data-price-display]');
      var submitButton = document.querySelector('.product-form__submit');
      if (!priceDisplay) return;

      /* Remove any sibling compare-price <s> (created by quantity-picker) to avoid duplicates */
      var siblingCompare = priceDisplay.parentNode && priceDisplay.parentNode.querySelector('.product-form__submit-compare-price');
      if (siblingCompare) siblingCompare.remove();

      if (isSubscription) {
        var discount = Math.round(effective.price * discountPercentage / 100);
        var finalPrice = effective.price - discount;
        var beforePrice = effective.compareAtPrice || effective.price;
        priceDisplay.innerHTML =
          '<span class="price-discounted">' + formatMoney(finalPrice) + '</span>' +
          '<span class="price-before-discount">' + formatMoney(beforePrice) + '</span>';
        if (submitButton) submitButton.dataset.productPrice = String(finalPrice);
      } else {
        if (effective.compareAtPrice) {
          priceDisplay.innerHTML =
            '<span class="price-discounted">' + formatMoney(effective.price) + '</span>' +
            '<span class="price-before-discount">' + formatMoney(effective.compareAtPrice) + '</span>';
        } else {
          priceDisplay.textContent = formatMoney(effective.price);
        }
        if (submitButton) submitButton.dataset.productPrice = String(effective.price);
      }
    }

    /* ── product form manipulation ── */

    function isDrawerForm(form) {
      return !!(form.closest('cart-drawer') ||
                form.closest('#CartDrawer') ||
                form.classList.contains('upsell-drawer-form'));
    }

    function findProductForm() {
      /* Le formulaire produit principal est le seul à porter un input section-id
         (généré par {% form 'product' %}). Le drawer et les upsells en rendent
         d'autres, plus haut dans le DOM : même exclusion que bundle-pack-presets.js:29-40,
         sinon le selling_plan atterrit dans un formulaire d'upsell et n'arrive jamais. */
      var forms = document.querySelectorAll('form[action*="/cart/add"]');
      var fallback = null;
      for (var i = 0; i < forms.length; i++) {
        if (isDrawerForm(forms[i])) continue;
        if (forms[i].querySelector('input[name="section-id"]')) return forms[i];
        if (!fallback) fallback = forms[i];
      }
      return fallback;
    }

    function updateProductForm(selected) {
      var form = findProductForm();
      if (!form) return;

      /* selling_plan — remove ALL existing inputs (Seal may inject its own) */
      var allPlanInputs = form.querySelectorAll('input[name="selling_plan"]');
      allPlanInputs.forEach(function (el) { el.remove(); });

      if (selected === 'subscribe' && sellingPlanId) {
        var planInput = document.createElement('input');
        planInput.type = 'hidden';
        planInput.name = 'selling_plan';
        planInput.value = sellingPlanId;
        form.appendChild(planInput);
      }

      /* frequency as line-item property */
      var existingFreq = form.querySelector('input[name="properties[frequency]"]');
      if (existingFreq) existingFreq.remove();

      if (selected === 'subscribe' && showFrequency && frequencySelect) {
        var freqInput = document.createElement('input');
        freqInput.type = 'hidden';
        freqInput.name = 'properties[frequency]';
        freqInput.value = frequencySelect.value || defaultFrequency;
        form.appendChild(freqInput);
      }

      /* custom event for other scripts */
      form.dispatchEvent(new CustomEvent('purchase-option:change', {
        detail: {
          option: selected,
          sellingPlanId: sellingPlanId,
          frequency: frequencySelect ? frequencySelect.value : null
        }
      }));
    }

    /* ── refresh ── */

    function refresh() {
      var checked = container.querySelector('input[type="radio"]:checked');
      var selected = checked ? checked.value : 'one_time';
      updatePrices(selected === 'subscribe');
      updateButtonPrice(selected === 'subscribe');
    }

    /* ── bundle-pack-addon.js integration ── */

    document.addEventListener('bundlePackPrice:change', function (e) {
      var detail = e.detail;
      if (!detail) return;
      if (detail.hasSelections && detail.totalPrice > 0) {
        bundlePrice = detail.totalPrice;
        bundlePriceBeforeDiscount = detail.totalPriceBeforeDiscount || null;
      } else {
        bundlePrice = null;
        bundlePriceBeforeDiscount = null;
      }
      refresh();
    });

    /* ── simple bundle-picker integration ──
       Skip when bundle-pack is present — prices come from bundlePackPrice:change */

    if (!document.querySelector('[data-bundle-pack]')) {
      document.addEventListener('click', function (e) {
        var option = e.target.closest('.bundle-picker__option');
        if (!option) return;
        setTimeout(function () {
          var activeOption = document.querySelector('.bundle-picker__option.is-active');
          if (!activeOption) return;
          var parsed = parsePriceString(activeOption.dataset.price || activeOption.dataset.atcPrice);
          var parsedCompare = parsePriceString(activeOption.dataset.comparePrice || activeOption.dataset.atcComparePrice);
          if (parsed !== null && parsed > 0) {
            bundlePrice = parsed;
            bundlePriceBeforeDiscount = (parsedCompare && parsedCompare > parsed) ? parsedCompare : null;
          } else {
            bundlePrice = null;
            bundlePriceBeforeDiscount = null;
          }
          refresh();
        }, 50);
      });
    }

    /* ── radio change listeners ── */

    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        var selected = this.value;
        applyVisualState(selected);
        updateProductForm(selected);
        updatePrices(selected === 'subscribe');
        updateButtonPrice(selected === 'subscribe');
        /* Sync with Seal: send selling_plan_id or empty string for one-time */
        syncWithSeal(selected === 'subscribe' ? sellingPlanId : '');
      });
    });

    /* ── clickable cards (click anywhere on card toggles radio) ── */

    if (subscribeCard) {
      subscribeCard.addEventListener('click', function (e) {
        if (e.target.type === 'radio' || e.target.tagName === 'SELECT' || e.target.closest('.subscribe-radio__frequency-select')) return;
        var radio = subscribeCard.querySelector('input[type="radio"]');
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    if (onetimeCard) {
      onetimeCard.addEventListener('click', function (e) {
        if (e.target.type === 'radio') return;
        var radio = onetimeCard.querySelector('input[type="radio"]');
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    /* ── frequency change ── */

    if (frequencySelect) {
      frequencySelect.addEventListener('change', function () {
        var checked = container.querySelector('input[type="radio"]:checked');
        updateProductForm(checked ? checked.value : 'one_time');
      });
    }

    /* ── Seal Subscriptions integration ── */

    /* Hide the native Seal widget if it appears after our block */
    document.addEventListener('sealsubs:subscription_widget_created', function () {
      var sealWidgets = document.querySelectorAll('.sealsubs-target-element, .seal-subscription-widget, [data-seal-extension]');
      sealWidgets.forEach(function (w) { w.style.display = 'none'; });
    });

    /* Prevent Seal from re-injecting selling_plan inputs we don't want */
    (function () {
      var form = findProductForm();
      if (!form) return;
      var observer = new MutationObserver(function () {
        var checked = container.querySelector('input[type="radio"]:checked');
        var isSubscribe = checked && checked.value === 'subscribe';
        var planInputs = form.querySelectorAll('input[name="selling_plan"]');

        if (!isSubscribe) {
          /* One-time mode: remove ALL selling_plan inputs (Seal may inject empty ones) */
          planInputs.forEach(function (el) { el.remove(); });
        } else if (planInputs.length > 1) {
          /* Subscribe mode: keep only the last one (ours), remove Seal duplicates */
          for (var i = 0; i < planInputs.length - 1; i++) {
            planInputs[i].remove();
          }
        }
      });
      observer.observe(form, { childList: true, subtree: true });
    })();

    /* Sync our selection with Seal's internal state */
    function syncWithSeal(planId) {
      var sealWidget = document.querySelector('.sealsubs-target-element');
      if (sealWidget) {
        sealWidget.dispatchEvent(new CustomEvent('sealsubs:change_selected_selling_plan_id', {
          detail: { selling_plan_id: planId || '' }
        }));
      }
    }

    /* Listen for Seal price updates — ignore them entirely.
       We handle all subscription price display ourselves via
       getEffectivePrice() + discountPercentage. Seal's price_update
       was overwriting our calculated prices (especially the abo discount). */

    /* Listen for Seal selling plan changes (e.g. if Seal updates the plan) */
    document.addEventListener('sealsubs:selling_plan_changed', function (e) {
      var detail = e.detail;
      if (detail && detail.selling_plan_id) {
        sellingPlanId = String(detail.selling_plan_id);
        var checked = container.querySelector('input[type="radio"]:checked');
        if (checked && checked.value === 'subscribe') {
          updateProductForm('subscribe');
        }
      }
    });

    /* ── guard: force correct selling_plan just before submit ── */
    /* Seal can overwrite our selling_plan input with an empty value after
       init. By listening in the capture phase we run BEFORE product-form.js
       reads the FormData, so the correct value is always submitted. */
    (function () {
      var form = findProductForm();
      if (!form) return;
      form.addEventListener('submit', function () {
        var checked = container.querySelector('input[type="radio"]:checked');
        var isSubscribe = checked && checked.value === 'subscribe';

        /* Remove all existing selling_plan inputs */
        var inputs = form.querySelectorAll('input[name="selling_plan"]');
        inputs.forEach(function (el) { el.remove(); });

        if (isSubscribe && sellingPlanId) {
          var inp = document.createElement('input');
          inp.type = 'hidden';
          inp.name = 'selling_plan';
          inp.value = sellingPlanId;
          form.appendChild(inp);
        }
      }, true); /* capture phase = runs before product-form.js handler */
    })();

    /* ── initial state ── */

    /* Pick up the quantity-picker's active option price at init
       Skip when bundle-pack is present — it manages prices via bundlePackPrice:change event */
    if (!document.querySelector('[data-bundle-pack]')) {
      var initActiveOption = document.querySelector('.bundle-picker__option.is-active');
      if (initActiveOption) {
        var initParsed = parsePriceString(initActiveOption.dataset.price || initActiveOption.dataset.atcPrice);
        var initParsedCompare = parsePriceString(initActiveOption.dataset.comparePrice || initActiveOption.dataset.atcComparePrice);
        if (initParsed !== null && initParsed > 0) {
          bundlePrice = initParsed;
          bundlePriceBeforeDiscount = (initParsedCompare && initParsedCompare > initParsed) ? initParsedCompare : null;
        }
      }
    }

    var initiallySelected = defaultSubscription ? 'subscribe' : 'one_time';
    applyVisualState(initiallySelected);
    updateProductForm(initiallySelected);
    updatePrices(initiallySelected === 'subscribe');
    updateButtonPrice(initiallySelected === 'subscribe');

    /* Sync initial state with Seal */
    if (initiallySelected === 'subscribe' && sellingPlanId) {
      syncWithSeal(sellingPlanId);
    }

    /* ── variant change hooks (FLOWEE pubsub) ── */

    function hasBundlePackActive() {
      var bp = document.querySelector('[data-bundle-pack]');
      return bp && bp.bundlePackAddon && bp.bundlePackAddon.selectedVariants && bp.bundlePackAddon.selectedVariants.size > 0;
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        if (!hasBundlePackActive()) {
          bundlePrice = null;
          bundlePriceBeforeDiscount = null;
        }
        refresh();
        var checked = container.querySelector('input[type="radio"]:checked');
        updateProductForm(checked ? checked.value : 'one_time');
      });
    }

    /* fallback DOM event */
    document.addEventListener('variant:change', function () {
      if (!hasBundlePackActive()) {
        bundlePrice = null;
        bundlePriceBeforeDiscount = null;
      }
      refresh();
    });
  }

  /* Run immediately – script tag is placed after the HTML */
  function run() {
    document.querySelectorAll('.subscribe-radio').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
